import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab5',
  templateUrl: './awsop-lab5.component.html',
  styleUrls: ['./awsop-lab5.component.css']
})
export class AwsopLab5Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab5/awsop-lab5.component.ts